"use client";
import Link from "next/link";
import { InstagramLogo } from "../base/Footer";
import Logo from "../base/Logo";
import Text from "../text";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../ui/dialog";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Button } from "../ui/button";

export default function ContactUsPopup() {
  const [open, setOpen] = useState<boolean>(false);
  useEffect(() => {
    const unix = JSON.parse(localStorage.getItem("popup/contactus") || "null");
    const open = !unix
      ? true
      : new Date().getTime() > unix + 6 * 60 * 60 * 1000;

    if (open) {
      const timeout = setTimeout(() => {
        setOpen(true);
        localStorage.setItem(
          "popup/contactus",
          JSON.stringify(new Date().getTime())
        );
        window.addEventListener("unload", (_) => {
          localStorage.removeItem("popup/contactus");
        });
      });
      return () => clearTimeout(timeout);
    }
  }, []);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-4xl max-h-[95svh] bg-background-accent overflow-y-auto">
        <DialogTitle />
        <DialogDescription />
        <div className="flex flex-col md:grid md:grid-cols-2 items-center gap-8">
          <Image
            src="/shared/contactpopup/featured.webp"
            width={512}
            height={512}
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="flex flex-col items-start justify-between gap-8">
            <Logo className="h-14" />
            <Text className="font-body text-3xl tracking-[0px] font-semibold">
              {"Get a Free upgrade to our Limousine Hearse today"}
            </Text>
            <div>
              <DialogClose asChild>
                <Button>Redeem Now</Button>
              </DialogClose>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
